import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider } from "react-redux";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

try {
  const convertParamToJson = b64_to_utf8(window.location.search.substring(1))
    ?.length
    ? JSON.parse(b64_to_utf8(window.location.search.substring(1)))
    : {};
  let parseData = { ...convertParamToJson };

  if (convertParamToJson["preview"] !== undefined) {
    window.shopPreview = convertParamToJson["shop"];
    delete parseData["preview"];
    delete parseData["shop"];
    window.dynamicReview = parseData;
    localStorage.removeItem("preventReload");
    if (localStorage.getItem("preventReload"))
      delete parseData["tracking_number"];
  } else {
    window.dynamicReview = false;
  }
} catch (error) {
  console.log(error);
  window.dynamicReview = false;
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function b64_to_utf8(str) {
  if (str && str.length && !str.includes("tracking_number")) {
    return decodeURIComponent(escape(window.atob(str)));
  }
}
